import BaseValidator from 'services/validations/base-validator';
import {interpret} from 'dictionary';

class Validator extends BaseValidator {
    private rulesName: string = interpret('player combination rules');
    protected runValidation(): void {
        this.validatePrimaryGroup();
        this.validateSecondaryGroup();
        this.validateTotalMinPlayersInStackItem();
    }

    private validatePrimaryGroup(): void {
        if (this.isMinPlayersGreaterThanMaxInPrimaryGroup()) {
            this.addError(`Min players value is greater than max in ${this.rulesName}.`);
        }
        if (this.isNotEnoughPlayersSelectedInPrimaryGroup()) {
            this.addError(`Not enough players selected in ${this.rulesName}.`);
        }
    }

    private validateSecondaryGroup(): void {
        // @ts-ignore
        const {stackItem} = this.dependencies;
        if (!stackItem.isSecondaryGroupUsed()) {
            return;
        }
        if (this.isMinPlayersGreaterThanMaxInSecondaryGroup()) {
            this.addError(`Min players value is greater than max in ${this.rulesName}.`);
        }
        if (this.isNotEnoughPlayersSelectedInSecondaryGroup()) {
            this.addError(`Not enough players selected in ${this.rulesName}.`);
        }
        if (this.isPlayersFromGroupsIntersected()) {
            this.addError(`Players cannot be duplicated in ${this.rulesName}.`);
        }
    }

    private validateTotalMinPlayersInStackItem(): void {
        // @ts-ignore
        const {stackItem, sportConfig} = this.dependencies;
        if (!stackItem.isSecondaryGroupUsed()) {
            return;
        }
        const totalMin = stackItem.getMinPlayersInPrimaryGroup() + stackItem.getMinPlayersInSecondaryGroup();
        if (totalMin > sportConfig.getConfigProp('playersInTeam')) {
            this.addError(`Sum of min players is greater than quantity of players in a lineup in ${this.rulesName}.`);
        }
    }

    private isMinPlayersGreaterThanMaxInPrimaryGroup() {
        // @ts-ignore
        const {stackItem} = this.dependencies;

        const min = stackItem.getMinPlayersInPrimaryGroup();
        const max = stackItem.getMaxPlayersInPrimaryGroup();

        return min > max;
    }

    private isNotEnoughPlayersSelectedInPrimaryGroup(): boolean {
        // @ts-ignore
        const {stackItem} = this.dependencies;

        const max = stackItem.getMaxPlayersInPrimaryGroup();
        const playersQuantity = stackItem.getPlayerIdsInPrimaryGroup().length;

        return max > playersQuantity;
    }

    private isMinPlayersGreaterThanMaxInSecondaryGroup(): boolean {
        // @ts-ignore
        const {stackItem} = this.dependencies;

        const min = stackItem.getMinPlayersInSecondaryGroup();
        const max = stackItem.getMaxPlayersInSecondaryGroup();

        return min > max;
    }

    private isNotEnoughPlayersSelectedInSecondaryGroup(): boolean {
        // @ts-ignore
        const {stackItem} = this.dependencies;

        const max = stackItem.getMaxPlayersInSecondaryGroup();
        const playersQuantity = stackItem.getPlayerIdsInSecondaryGroup().length;

        return max > playersQuantity;
    }

    private isPlayersFromGroupsIntersected(): boolean {
        // @ts-ignore
        const {stackItem} = this.dependencies;

        const primaryGroupPlayerIds = stackItem.getPlayerIdsInPrimaryGroup();
        const secondaryGroupPlayerIds = stackItem.getPlayerIdsInSecondaryGroup();

        return 0 < arrayDuplicates(primaryGroupPlayerIds, secondaryGroupPlayerIds).length;
    }
}

export default Validator;
